module.exports = __webpack_public_path__ + "img/phone_in_talk.f3911061.svg";